import PropertyPhotoModal from './PropertyPhotoModal';

export default PropertyPhotoModal;
